import * as React from "react";
import {
    FloatingTools,
    IFloatingTool,
    useHasFloatingToolTargets,
} from "source/app/presentation/Shared/FloatingTools/FloatingTools";
import { DreamsScrollIcon } from "./DreamsScrollIcon/DreamsScrollIcon";
import { DreamNameExpansionTool } from "./NameExpansion/DreamNameExpansionTool";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { useDreamNameExpansion } from "../NameExpansion/DreamNameExpansionContext";

export interface IDreamsFloatingToolInputs {
    hasDreamRows: boolean;
    canExpandAll: boolean;
    canCollapseAll: boolean;
    expandAll: () => void;
    collapseAll: () => void;
}

export const dreamsFloatingTools: IFloatingTool<IDreamsFloatingToolInputs>[] = [
    {
        name: `dreamsScrollToTop`,
        toRender: (inputs) => (
            <DreamsScrollIcon
                direction="up"
                disabled={!inputs.hasDreamRows}
            />
        ),
        iconColor: `#4bc5ed`,
        tooltip: `Scroll to first dream`,
        isDisabled: (inputs) => !inputs.hasDreamRows,
    },
    {
        name: `dreamsScrollToBottom`,
        toRender: (inputs) => (
            <DreamsScrollIcon
                direction="down"
                disabled={!inputs.hasDreamRows}
            />
        ),
        iconColor: `#4bc5ed`,
        tooltip: `Scroll to last dream`,
        isDisabled: (inputs) => !inputs.hasDreamRows,
    },
    {
        name: `dreamsExpandAll`,
        toRender: (inputs) => (
            <DreamNameExpansionTool
                action={inputs.expandAll}
                disabled={!inputs.canExpandAll}
                icon={EGlyphicon["resize-full"]}
                label="Expand all dream names"
            />
        ),
        isDisabled: (inputs) => !inputs.canExpandAll,
        tooltip: `Expand all`,
        iconColor: `#4bc5ed`,
    },
    {
        name: `dreamsCollapseAll`,
        toRender: (inputs) => (
            <DreamNameExpansionTool
                action={inputs.collapseAll}
                disabled={!inputs.canCollapseAll}
                icon={EGlyphicon["resize-small"]}
                label="Collapse all dream names"
            />
        ),
        isDisabled: (inputs) => !inputs.canCollapseAll,
        tooltip: `Collapse all`,
        iconColor: `#4bc5ed`,
    },
];

export function DreamsFloatingTools() {
    const hasDreamRows = useHasFloatingToolTargets("[data-dream-row]");
    const {
        expandableDreamIds,
        expandedDreamIds,
        expandAll,
        collapseAll,
    } = useDreamNameExpansion();
    const canExpandAll = Array.from(expandableDreamIds).some(
        (dreamId) => !expandedDreamIds.has(dreamId)
    );
    const canCollapseAll = expandedDreamIds.size > 0;

    return FloatingTools(
        {
            hasDreamRows,
            canExpandAll,
            canCollapseAll,
            expandAll,
            collapseAll,
        },
        dreamsFloatingTools
    );
}
